import Vue from 'vue';
import VueSimpleSpinner from 'vue-simple-spinner';
import {UserRoleEnum} from '@/enums/userRolesEnum';
import GenericModal from '@/componentsReusable/genericModal.vue';
import UploadControl from '@/componentsReusable/UploadControl.vue';
import HttpMixin from '@/mixins/HttpMixin';
import {AppEntityType} from '@/enums/AppEntityType';

export default Vue.component('potential-invoice-attachments-card', {
  name: 'PotentialInvoiceAttachmentsCard',
  props: {
    facilityId: { type: [Number, String] },
    specialtyId: { type: [Number, String] },
    invoiceStartDate: { type: [Date, String] }
  },
  data () {
    return {
      cardExpanded: false,
      loadingInitialData: false,
      attachments: [] as any[],
      isAuthorizedToDelete: false,
      showConfirmationModal: false,
      pendingDeleteId: null,
      uploadPath: 'invoices/potential/attachments/',
      entityId: 0,
      entityType: AppEntityType.POTENTIAL_INVOICE_ATTACHMENT
    }
  },
  components: {
    VueSimpleSpinner,
    UploadControl,
    GenericModal
  },
  mixins: [ HttpMixin ],
  beforeMount: function () {
    this.isAuthorizedToDelete = this.$store.getters['user/hasRole']([UserRoleEnum.MANAGER]);
  },
  methods: {
    async expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        await this.getAttachments()
      }
    },
    async getAttachments () {
      const url = `/invoices/attachments?facilityId=${this.facilityId}&specialtyId=${this.specialtyId}&invoiceDate=${this.invoiceStartDate}`;
      const data = await (this as any).httpGet(url, 'Error retrieving Attachments');
      if (data) {
        this.attachments = data.attachments;
        this.entityId = data.id;
      }
    },
    async associateUploadedFile (s3FilePath: string, fileName: string) {
      try {
        const body = {
          entityId: this.entityId,
          entityType: this.entityType,
          attachmentName: fileName,
          s3Key: s3FilePath
        };
        await (this as any).httpPost('/attachment/', 'Error associating uploaded Attachment', body);
        this.$notify({
          group: 'main',
          type: 'success',
          title: `Successful Attachment Upload`,
          text: 'Attachment ' + fileName + ' has been successfully uploaded.'
        });
        await this.getAttachments();
      } catch (err) {
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred saving uploaded Attachment.'
        });
      }
    },
    async open (s3Key: string) {
      const data = await (this as any).httpGet(`/s3/signed-url/get-secure?s3key=${s3Key}`, 'Error getting Attachment');
      if (data) {
        window.open(data, '_blank');
      }
    },
    async deleteConfirmed (id: any) {
      this.showConfirmationModal = false;
      await this.deleteAttachment(this.pendingDeleteId, true);
    },
    async deleteAttachment (id: any, bypassDeleteConfirmation: boolean = false ) {
      if (!bypassDeleteConfirmation) {
        // Show Delete Confirmation Modal
        this.showConfirmationModal = true;
        this.pendingDeleteId = id;
        return;
      } else {
        this.pendingDeleteId = null;
      }
      await (this as any).httpDelete('/attachments/' + id, 'An error occurred deleting Attachment');
      this.attachments = this.attachments.filter(attachment => attachment.id !== id);
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/invoice/cards/potentialAttachments/PotentialInvoiceAttachmentsCard.ts